import React from "react";
import { Button, Icon } from "../_components";

export function TimelineScroller({ containerRef, timelineSlots }) {
  const handleScrollUp = (ev) => {
    if (!containerRef.current) return;
    containerRef.current.scrollUp();
  };

  const handleScrollDown = (ev) => {
    if (!containerRef.current) return;
    containerRef.current.scrollDown();
  };

  return (
    <div className="chronos-timeline-scroll-control">
      <Button onClick={handleScrollUp} iconOnly>
        <Icon icon="fas fa-triangle fa-fw" />
      </Button>
      <Button onClick={handleScrollDown} iconOnly>
        <Icon icon="fas fa-triangle fa-rotate-180 fa-fw" />
      </Button>
    </div>
  );
}
